import React from 'react';
import { useLanguage } from '@/state/language/LanguageProvider';
import { AE_MUTED, AE_SECTION_TITLE } from '@/components/assessment-engine/layout/aeTheme';
import type { AeRespondentFraming } from '@/types/assessmentEngine';

export interface TakeAssessmentOpeningFramingProps {
  framing?: AeRespondentFraming | null;
}

/** Purpose and instructions above the entry card — no border, outside the take-flow box. */
export const TakeAssessmentOpeningFraming: React.FC<TakeAssessmentOpeningFramingProps> = ({ framing }) => {
  const { t } = useLanguage();
  const purpose = framing?.opening?.purpose?.trim();
  const instructions = framing?.opening?.instructions?.trim();

  if (!purpose && !instructions) return null;

  return (
    <div className="mb-6 space-y-4">
      {purpose && (
        <div>
          <h2 className={AE_SECTION_TITLE}>{t('assessmentEngine.take.purpose')}</h2>
          <p className={`${AE_MUTED} mt-2 whitespace-pre-wrap text-sm`}>{purpose}</p>
        </div>
      )}
      {instructions && (
        <div>
          <h2 className={AE_SECTION_TITLE}>{t('assessmentEngine.take.instructions')}</h2>
          <p className={`${AE_MUTED} mt-2 whitespace-pre-wrap text-sm`}>{instructions}</p>
        </div>
      )}
    </div>
  );
};
